import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Help extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <path
            d="M8.5,11.8h-2c0-2.8,1.6-3.9,2.8-4.7C10.5,6.4,11,6,11,4.8C11,3,9.8,2,7.8,2C5.2,2,5,3.8,5,4.3H3
          C3,2.7,4,0,7.8,0C11.6,0,13,2.6,13,4.8c0,2.4-1.5,3.3-2.6,4.1C9.3,9.6,8.5,10.1,8.5,11.8z"
          />
          <rect x="6.5" y="14.2" width="2" height="1.8" />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Help.js